import CustomCard from '../../../components/CustomCard.tsx'
import { CheckBoxComponent, ChangeEventArgs } from '@syncfusion/ej2-react-buttons'
import { FC, useEffect, useState } from 'react'
import styles from './TopicSelection.module.scss'
import { NwTopicArea } from '../../../types/settingTypes/NwTopicArea.tsx'
import { fetchDataFromApi } from '../../../services/fetchDataFromApi.tsx'
import { useOidcAccessToken } from '@axa-fr/react-oidc'
import { protectedResources } from '../../../global/config.tsx'
import { NwInstructorsSkills } from '../../../types/settingTypes/NwInstructorsSkills.tsx'
import { useFormContext } from 'react-hook-form'

interface ITopicSelectionProps {
  sub: string | undefined
}

const TopicSelection: FC<ITopicSelectionProps> = ({ sub }) => {
  const [checkedItems, setCheckedItems] = useState<NwInstructorsSkills[]>([])
  const [items, setItems] = useState<NwTopicArea[]>([])
  const [otherText, setOtherText] = useState<string>('')
  const { accessToken } = useOidcAccessToken()

  const {
    setValue,
    getValues,
    watch,
    register,
    formState: { errors },
  } = useFormContext()

  useEffect(() => {
    //Werte von der API holen
    const url = protectedResources.apiList.readTopicAreas
    fetchDataFromApi(url, accessToken, 'GET', 'json').then((response) => {
      if (response.status === 200) {
        const data = response.data as NwTopicArea[]
        setItems(data)
      }
    })
  }, [])

  const skills = watch('actualIndex')
  useEffect(() => {
    const si = getValues('skills')
    if (Array.isArray(si)) setCheckedItems(si)
  }, [skills])

  const handleCheck = (event: ChangeEventArgs, item: NwTopicArea) => {
    const updatedList = event.checked ? [...checkedItems, { besthmbrId: item.id, sub: sub } as NwInstructorsSkills] : checkedItems.filter((i) => i.besthmbrId !== item.id)

    setCheckedItems(updatedList)

    setValue('skills', updatedList)
  }

  return (
    <>
      <CustomCard header={'Wählen Sie die Themengebiete nach Ihrer Expertise:'}>
        <div className={styles.App}>
          <div className={styles.listContainer}>
            {items.map((item, index) => (
              <div key={`${index}`} className={styles.listItem}>
                <CheckBoxComponent {...register('skills', { required: 'Bitte wählen Sie mindestens ein Themengebiet aus.' })} checked={checkedItems?.some((checkedItem) => checkedItem.besthmbrId === item.id) || false} label={item.description} change={(event) => handleCheck(event, item)} />
              </div>
            ))}
          </div>
          {errors.skills && <p className="errorMsg">{errors.skills?.message as string}</p>}

          <div className={styles.otherTextContainer}>
            <label htmlFor="otherText" className={styles.otherTextLabel}>
              Ihre Themenvorschläge:
            </label>
            <textarea name="otherText" className={styles.textarea} defaultValue={otherText} onChange={(e) => setOtherText(e.target.value)} placeholder="Bitte geben Sie hier Ihren Text ein..." />
          </div>
        </div>
      </CustomCard>
    </>
  )
}

export default TopicSelection
